import serializeParams from 'lib/utils/url';

/**
 * amount, deal_ids, pan
 */
export default (axios, params) => axios.get(`/payout-details/?${serializeParams(params)}`);
